import { Upgrade as CommonUpgrade } from 'components/common';
import { useUser } from 'libs';

interface UpgradeProps {
  isPro?: boolean | null;
  [key: string]: any;
}

const Upgrade = ({ isPro = null, ...props }: UpgradeProps) => {
  const user = useUser();

  if (!isPro || user.features.is_pro) return null;

  return <CommonUpgrade className="btn btn-upgrade btn-sm" {...props} />;
};

export default Upgrade;
